import React from "react";
import LandingNav from "../components/Landing-Nav.js";
import FooterLanding from "../components/FooterLanding.js";
import { LineChart,Users,Settings  } from "lucide-react";


export default function PredictiveAnalyticsComponent() {
  return (
    <>
      <LandingNav />

      {/* Hero Section */}
      <section className="font-inter bg-gray-50 py-16 px-6 lg:px-20">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Shiftry | Predictive Analytics
          </h1>
          <p className="text-lg text-gray-600 max-w-3xl">
            Smarter scheduling, powered by data. Anticipate demand, align Employee,
            and deploy teams with precision. Shiftry turns your operational data
            into accurate forecasts and practical staffing plans—so service
            leaders reduce costs, protect service levels, and deliver
            consistently great experiences.
          </p>
        </div>
      </section>

      {/* Engines Section */}
      <section className="py-16 px-6 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-6">
            The three engines of Predictive Analytics
          </h2>
          <p className="text-gray-600 mb-10">
            Each engine is built for service operations, designed to work
            together or independently.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white shadow-md rounded-xl p-6">
              <h3 className="flex items-center gap-2 font-semibold text-lg mb-2">
      <LineChart className="w-5 h-5 text-indigo-600" />
      Sales Forecasting
    </h3>
              <p className="text-gray-600">
                Multi-factor models project daily and hourly revenue using
                seasonality, promotions, weather, and local events, giving
                managers the clarity to plan with confidence.
              </p>
            </div>
            <div className="bg-white shadow-md rounded-xl p-6">
              <h3 className="flex items-center gap-2 font-semibold text-lg mb-2">
      <Users className="w-5 h-5 text-indigo-600" />
      Labour Demand
    </h3>
              <p className="text-gray-600">
                Translate forecasted sales into staffing needs by skill and
                location. Balance SLAs and cost with role-based thresholds and
                dynamic productivity curves.
              </p>
            </div>
            <div className="bg-white shadow-md rounded-xl p-6">
              <h3 className="flex items-center gap-2 font-semibold text-lg mb-2">
      <Settings className="w-5 h-5 text-indigo-600" />
      Smart Deployment
    </h3>
              <p className="text-gray-600">
                Generate deployable schedules that respect availability,
                contracts, and travel time. Optimize shift start times and
                coverage to meet real-world constraints.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Proven Impact Section */}
      <section className="bg-indigo-50 py-16 px-6 lg:px-20">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-6">
            Proven impact, measurable results
          </h2>
          <p className="text-gray-600 mb-10">
            Early adopters report leaner operations and stronger service KPIs
            across locations.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl shadow-md p-6">
              <p className="text-2xl font-bold text-indigo-600">8–12%</p>
              <p className="text-gray-600">Lower Employee cost per sale</p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
              <p className="text-2xl font-bold text-indigo-600">+18 pts</p>
              <p className="text-gray-600">On-time SLA adherence</p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
              <p className="text-2xl font-bold text-indigo-600">3x</p>
              <p className="text-gray-600">Faster planning cycle</p>
            </div>
          </div>
          <p className="text-sm text-gray-500 mt-6">
            Teams also cite clearer staffing guidance, fewer last-minute
            changes, and better cross-site coordination.
          </p>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className="py-16 px-6 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-10">
            Why choose Shiftry Analytics?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="font-semibold mb-2">Purpose-built models</h3>
              <p className="text-gray-600">
                Tuned for service operations with explainable drivers managers
                trust.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="font-semibold mb-2">Easy integrations</h3>
              <p className="text-gray-600">
                Connect POS, WFM, and HRIS data with prebuilt connectors and
                secure APIs.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="font-semibold mb-2">Enterprise-grade controls</h3>
              <p className="text-gray-600">
                Role-based access, audit trails, and regional data residency.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow">
              <h3 className="font-semibold mb-2">Operational impact</h3>
              <p className="text-gray-600">
                From forecast to schedule, insights flow directly into daily
                decisions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 lg:px-20 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
            Bring Predictive Analytics into your workflow today
          </h2>
          <p className="text-gray-600 mb-8">
            See how Shiftry streamlines staffing decisions across your
            locations. Talk to a specialist or try a guided demo with your own
            scenarios.
          </p>
          
        </div>
      </section>

      <FooterLanding />
    </>
  );
}
